/**
 * Authentication Layout Component
 * 用於登入/註冊頁面的布局
 * 響應式設計適配三種解析度
 */
import { Outlet } from 'react-router-dom';
import { Layout, theme, Grid } from 'antd';

const { Content } = Layout;
const { useBreakpoint } = Grid;

const AuthLayout = () => {
  const { token } = theme.useToken();
  const screens = useBreakpoint();

  const isMobile = !screens.md; // <768px
  const isTablet = screens.md && !screens.xl; // 768-1200px

  return (
    <Layout style={{ minHeight: '100vh', background: token.colorBgLayout }}>
      <Content
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: isMobile ? '20px' : '40px',
        }}
      >
        <div
          style={{
            width: '100%',
            maxWidth: isMobile ? '100%' : isTablet ? '500px' : '600px',
            background: token.colorBgContainer,
            borderRadius: token.borderRadiusLG,
            padding: isMobile ? '24px' : isTablet ? '32px' : '40px',
            boxShadow: token.boxShadow,
          }}
        >
          {/* Logo */}
          <div style={{ textAlign: 'center', marginBottom: isMobile ? 24 : 32 }}>
            <h1
              style={{
                fontSize: isMobile ? 28 : 36,
                fontWeight: 'bold',
                color: token.colorPrimary,
                marginBottom: 8,
              }}
            >
              CDM-PDD
            </h1>
            <p style={{ color: token.colorTextSecondary, fontSize: isMobile ? 14 : 16 }}>
              碳權監測數據管理系統
            </p>
          </div>

          <Outlet />
        </div>
      </Content>
    </Layout>
  );
};

export default AuthLayout;
